import React from 'react'
import { View } from 'dripsy'

type Props = {
  height?: number | (number | null)[]
} & React.ComponentProps<typeof View>

export default function Spacer(props: Props) {
  const { sx = {}, height = [2, 3], ...rest } = props

  return <View sx={{ pb: height, ...sx }} {...rest} />
}
